/* eslint-disable */
<template>
  <div id="flybook_container"></div>
</template>
<script>
import "../../common/LarkSSOSDKWebQRCode-1.0.2.js"
export default {
  data() {
    return {
      // qrcode: ""
    };
  },
  computed: {},
  methods: {

    // 切换飞书
    changeFlyBook: function () {
      const vm = this;
      const fsState = `${vm.state}_fs`;
      const redirectUrl = "https://newsso.bthhotels.com/accountlogin/wxback";
      const clientID = `cli_a3d2293cfeba100b`;
      vm.$nextTick(() => {
        const params = {
          id: "flybook_container",
          goto: `https://passport.feishu.cn/suite/passport/oauth/authorize?client_id=${clientID}&redirect_uri=${redirectUrl}&response_type=code&state=${fsState}`,
          width: "260",
          height: "260",
           style: "border:none;", // 可选的，二维码html标签的style属性
        };
        const QRLoginObj = QRLogin(params);

        const handleMessage = function (event) {
          const origin = event.origin;
          // 使用 matchOrigin 方法来判断 message 来自页面的url是否合法
          if (QRLoginObj.matchOrigin(origin)) {
            const loginTmpCode = event.data;
            // 在授权页面地址上拼接上参数 tmp_code，并跳转
            window.location.href = `${params.goto}&tmp_code=${loginTmpCode}`;
          }
        };

        if (typeof window.addEventListener != "undefined") {
          window.addEventListener("message", handleMessage, false);
        } else if (typeof window.attachEvent != "undefined") {
          window.attachEvent("onmessage", handleMessage);
        }
      });
    },
  },
  mounted() {
    const vm = this;
    vm.$nextTick(function () {
      vm.changeFlyBook();
    });
  },
  props: {
    state: {
      type: String,
      default: "",
    },
  },
};
</script>
<style lang="scss" scoped>
@import "@css/style.scss";
[v-cloak] {
  display: none;
}
</style>
